import { DotsThree } from '@phosphor-icons/react';
import { Loader, VText } from '@vake/ui-kit';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { useGetSanctionedVesselTagsQuery } from '../../../requests/actor-mode';
import { useSendToMattermost } from '../../../requests/reports';
import { Flag } from '../../../shared/components/flag';
import { formatRelativeTime } from '../../../shared/components/time';
import { TagView } from './OverwatchRight';

export const ActorModeRow: FC<ActorModeRowProps> = ({ row, onClick }) => {
    const { data: tags, isLoading: tagsLoading, isError: tagsError } = useGetSanctionedVesselTagsQuery(row.vessel_id);
    const { mutate } = useSendToMattermost();

    const TagInRowView = () => {
        if (tagsLoading) {
            return (
                <div className="flex justify-center">
                    <Loader size={16} />
                </div>
            );
        }
        if (tagsError) {
            mutate(`In Morning Meeting: Error loading actions for ${row.vessel_id}`);
            return <></>;
        }
        if (!tags || tags.length === 0) {
            return <></>;
        }
        return <TagView tags={tags} />;
    };

    return (
        <Link
            to={`/actor-mode/${row.vessel_id}`}
            className="grid grid-cols-lmmmmss"
            key={row.vessel_id}
            onClick={() => onClick(row.vessel_id)}
        >
            <VText variant="B2">{row.name}</VText>
            <VText variant="B2">{row.imo}</VText>
            <div className="flex items-start gap-2">
                <Flag countryCode={row.flag} width={26} height={20} />
                <VText variant="B2">{row.mmsi}</VText>
            </div>
            <VText variant="B2">{formatRelativeTime(new Date(row.last_updated_ais))}</VText>
            <VText variant="B2">{row.last_position}</VText>
            <div className="flex flex-col gap-1">
                <TagInRowView />
            </div>
            <button className="flex items-center justify-end">
                <DotsThree />
            </button>
        </Link>
    );
};
